import { updateSubscription as u, createOrUpdateSubscription as s } from "../implementations/sub2/methods.js";
import { getFallbackQueryClient as o } from "../../utils/queryClient.js";
import { featuramaClient as a } from "../implementations/featurama/methods.js";
import { saasUiQueryKey as t } from "../utils/namespaceQueryKey.js";
import { ALL_FEATURES as l } from "./featurama.js";
const m = {
  getSquareOneEligibility: () => ({
    queryKey: t(["sub2", "getSquareOneEligibility"]),
    async queryFn() {
      const { getSquareOneEligibility: e } = await import("../implementations/sub2/methods.js");
      return e();
    },
    staleTime: Number.POSITIVE_INFINITY
  }),
  getPricingInfo: (e) => ({
    queryKey: t(["sub2", "getPricingInfo", { params: e }]),
    async queryFn() {
      const { getPricingInfo: i } = await import("../implementations/sub2/methods.js");
      return i(e);
    },
    staleTime: Number.POSITIVE_INFINITY
  }),
  listTrials: (e) => ({
    queryKey: t(["sub2", "listTrials", { params: e }]),
    async queryFn() {
      const { listTrials: i } = await import("../implementations/sub2/methods.js");
      return i(e);
    },
    enabled: !!e.planGroupToken,
    staleTime: 60 * 60 * 1e3
    // 1 hour
  }),
  getBillerLocationToken: (e) => ({
    queryKey: t(["sub2", "getBillerLocationToken", { params: e }]),
    async queryFn() {
      const { getBillerLocationToken: i } = await import("../implementations/sub2/methods.js");
      return i(e);
    }
  }),
  getPlanGroup: (e) => ({
    queryKey: t(["sub2", "getPlanGroup", { params: e }]),
    async queryFn() {
      const { getPlanGroup: i } = await import("../implementations/sub2/methods.js");
      return i(e);
    },
    enabled: !!e.token,
    staleTime: Number.POSITIVE_INFINITY
  }),
  getSquareOneSubscriptionInfo: (e = {}) => ({
    queryKey: t(["sub2", "getSquareOneSubscriptionInfo", { params: e }]),
    async queryFn() {
      const { getSquareOneSubscriptionInfo: i } = await import("../implementations/sub2/methods.js");
      return i(e);
    },
    staleTime: Number.POSITIVE_INFINITY
  }),
  createOrUpdateSubscription: {
    mutationKey: t(["sub2", "createOrUpdateSubscription"]),
    mutationFn(e) {
      return s(e);
    }
  },
  updateSubscription: {
    mutationKey: t(["sub2", "updateSubscription"]),
    mutationFn(e) {
      return u(e);
    }
  },
  getUiAssets: (e) => ({
    queryKey: t(["sub2", "getUiAssets", { params: e }]),
    async queryFn() {
      const { getUiAssets: i } = await import("../implementations/sub2/methods.js");
      return i(e);
    },
    staleTime: Number.POSITIVE_INFINITY
  })
};
async function p(e) {
  const i = [
    t(["sub2", "getPricingInfo"]),
    t(["sub2", "getSquareOneSubscriptionInfo"]),
    t(["sub2", "listTrials"]),
    t(["featurama", "bulkRetrieveFeatureStatuses"]),
    t(["sub2", "getUiAssets"])
  ], r = e ?? o();
  await a.bulkRetrieveFeatureStatuses({
    consistent: !0,
    keys: l
  }), await Promise.all(i.map((n) => r.invalidateQueries({ queryKey: n })));
}
export {
  p as invalidateSubscriptionStates,
  m as sub2
};
